'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ProductsAndPlansNavI;

var _ProductsAndPlansNavIds = require('pricing-pages-unified-ui/constants/ProductsAndPlansNavIds');

var _ProductsAndPlansNavIds2 = _interopRequireDefault(_ProductsAndPlansNavIds);

var _Marketing = require('bender-url!pricing-pages-unified-ui/img/productIcons/Marketing.svg');

var _Marketing2 = _interopRequireDefault(_Marketing);

var _Sales = require('bender-url!pricing-pages-unified-ui/img/productIcons/Sales.svg');

var _Sales2 = _interopRequireDefault(_Sales);

var _Service = require('bender-url!pricing-pages-unified-ui/img/productIcons/Service.svg');

var _Service2 = _interopRequireDefault(_Service);

var _CRM = require('bender-url!pricing-pages-unified-ui/img/productIcons/CRM.svg');

var _CRM2 = _interopRequireDefault(_CRM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_ProductsAndPlansNavI = {}, _defineProperty(_ProductsAndPlansNavI, _ProductsAndPlansNavIds2.default.MARKETING, _Marketing2.default), _defineProperty(_ProductsAndPlansNavI, _ProductsAndPlansNavIds2.default.SALES, _Sales2.default), _defineProperty(_ProductsAndPlansNavI, _ProductsAndPlansNavIds2.default.SERVICE, _Service2.default), _defineProperty(_ProductsAndPlansNavI, 'crm', _CRM2.default), _ProductsAndPlansNavI);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/constants/ProductPageIcons.js
// module id = 247
// module chunks = 3 4